import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * La grille des trois univers est ASYMÉTRIQUE à dessein : la Location occupe
 * toute la colonne de gauche, Shop et Services se partagent la droite. Trois
 * cartes identiques donneraient trois activités équivalentes, ce qui est faux —
 * et chaque univers porte sa propre couleur d'accent pour qu'on ne les
 * confonde jamais, ni ici ni sur les pages internes.
 */
const PATHS = [
  {
    to: "/location",
    label: "LOCATION",
    title: "Le matériel professionnel, chez vous le temps qu'il faut.",
    body: "Consoles, projecteurs, structure — choisissez vos dates, je prépare le matériel, vous venez le chercher et le ramenez à la fin, caution comprise.",
    cta: "Voir le catalogue",
    accent: "border-l-brand",
    labelColor: "text-brand",
    // row-span seulement à partir de md : en colonne unique, il créerait une
    // rangée vide sous la carte.
    className:
      "min-h-[340px] md:row-span-2 md:min-h-[520px] bg-[linear-gradient(160deg,hsl(var(--surface)),#0d2a3a)]",
    titleClass: "text-[34px]",
  },
  {
    to: "/shop",
    label: "SHOP",
    title: "Mes créations, prêtes à emporter.",
    body: "Horloges lumineuses, rubans pilotés, objets uniques imaginés et fabriqués ici.",
    cta: "Découvrir la boutique",
    accent: "border-l-amber",
    labelColor: "text-amber",
    className: "min-h-[250px] bg-surface",
    titleClass: "text-[26px]",
  },
  {
    to: "/services",
    label: "SERVICES",
    title: "Design et régie, du théâtre à la soirée.",
    body: "Création lumière, programmation, opération le jour J — seul ou combiné avec la location du matériel.",
    cta: "Demander un devis",
    accent: "border-l-violet",
    labelColor: "text-violet",
    className: "min-h-[250px] bg-surface",
    titleClass: "text-[26px]",
  },
];

export function PathsGrid() {
  return (
    <section className="container py-28">
      <div className="mb-12">
        <h2 className="max-w-[520px] font-display text-[clamp(28px,3.4vw,40px)] font-medium">
          Trois façons de travailler avec Lumosphere, selon ce dont vous avez besoin.
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-[1.35fr_1fr]">
        {PATHS.map((path) => (
          <Link
            key={path.to}
            to={path.to}
            className={cn(
              "group relative flex flex-col justify-end overflow-hidden rounded-2xl border border-hairline border-l-[3px] p-8 transition-transform duration-300 hover:-translate-y-1 md:p-11",
              path.accent,
              path.className,
            )}
          >
            <span className={cn("universe-label mb-3.5", path.labelColor)}>{path.label}</span>

            <h3
              className={cn(
                "mb-3 max-w-[380px] font-display font-medium",
                path.titleClass,
              )}
            >
              {path.title}
            </h3>

            <p className="mb-5 max-w-[380px] text-[15px] text-muted-foreground">{path.body}</p>

            <span className="inline-flex items-center gap-2 font-display text-[14.5px]">
              {path.cta}
              <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
